export class FakeScanner {
  private readonly messages = [
    'BANKIDF.74226FAAE3E64E70BB03F8E8E18D0439.8.79C416AA74278A70FAC25855F728A3206789B87B6FF6EB00688DB9622EFD2D33']

  constructor(private readonly cb: (r: any) => void) {
  }

  /**
   * Start should resolve a promise, but we do not care about
   * what data. In real life the "callback" is called when
   * a QR code is found. But we need to call it for testing.
   *
   * We use a "real" code as default so that we get majority
   * of testing for free
   *
   */
  public start(): Promise<any> {
    if (this.messages.length > 0 && this.cb) {
      this.cb({
        data: this.messages.pop()
      })
    }

    return Promise.resolve({})
  }

  public hasFlash(): Promise<any> {
    return Promise.resolve({})
  }

  public stop(): void {
    /**
     * Intentionally left blank
     */
  }

  public setCamera(): Promise<any> {
    return Promise.resolve({})
  }

  public toggleFlash(): Promise<any> {
    return Promise.resolve()
  }
}
